/** Task step UI for the welcome onboarding flow (first task capture). */
import { Box, Typography } from '@mui/material';
import { useT } from '@/i18n/useT';
import TaskInputQuick from '@/features/tasks/components/forms/TaskInputQuick';
import { ONBOARDING_WELCOME_STEP_TEST_IDS } from '@/features/onboarding/constants/welcomeStepTestIds';

/**
 * @param {Object} props
 * @param {(taskId: string, parsed: object) => void} props.onTaskAdded
 */
const OnboardingWelcomeTaskStep = ({ onTaskAdded }) => {
  const t = useT();

  return (
    <Box data-testid={ONBOARDING_WELCOME_STEP_TEST_IDS.task}>
      <Typography variant="h5" component="h1" gutterBottom>
        {t('onboarding.taskStep.title', 'Wat houdt je bezig?')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t('onboarding.taskStep.body', 'Schrijf er één op. De rest komt zo.')}
      </Typography>
      <TaskInputQuick
        inputId="onboarding-task-input"
        placeholder={t(
          'onboarding.taskStep.placeholder',
          'Bijvoorbeeld: offerte afmaken',
        )}
        disableEmptyNavigate
        showTokenPreview={false}
        onTaskAdded={onTaskAdded}
      />
    </Box>
  );
};

export default OnboardingWelcomeTaskStep;
